export default "__VITE_ASSET__Bq5RDgv8__"